'use strict';
module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// ./~/hast-util-to-html/index.js
// module id = 282
// module chunks = 35783957827783 251955352258861